export const PAYMENT_TYPES = ['cash', 'points', 'pointsPlusPay'] as const;

export type PaymentType = (typeof PAYMENT_TYPES)[number];
